import { makeStyles } from '@material-ui/core/styles'
import { DASHBOARD_BODY_TEXT } from 'pages/pga-coach/dashboard/dashboard-colors'

const DONUT_SIZE = 120

const useStyles = makeStyles(theme => ({
  panelBody: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    minHeight: DONUT_SIZE,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5),
    },
  },
  donut: {
    width: DONUT_SIZE,
    height: DONUT_SIZE,
    flexShrink: 0,
  },
  legend: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 0,
    flex: '0 1 220px',
    [theme.breakpoints.down('xs')]: {
      flex: '0 0 auto',
      width: '100%',
    },
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: DASHBOARD_BODY_TEXT,
  },
  legendSwatch: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0,
  },
  legendLabel: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  legendValue: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    color: theme.palette.text.secondary,
  },
  legendPercent: {
    flexShrink: 0,
    minWidth: 40,
    textAlign: 'right',
    fontWeight: 700,
  },
}))

export default useStyles
